import React from 'react';
import Box from '@material-ui/core/Box';

import { SectionTitle } from './Section.styled';

export const Section = ({ title, children }) => {
  return (
    <Box marginBottom={3}>
      {title && <SectionTitle variant="h6">{title}</SectionTitle>}
      {children}
    </Box>
  );
};
